import { SOLSEA_URL } from "../solana/common/utilities";
import { makeRequest } from "./utilities/http";
import {
  NFT_LISTED,
  RELOAD,
  SOLSEA_REFRESH_URI,
} from "./utilities/solsea.urls";

/**
 *
 * @param nftMint Mint of a nft to fetch from solsea api
 */
export const getNftDataFromSolsea = (nftMint: string) => {
  return makeRequest(
    "GET",
    `${NFT_LISTED}${nftMint}`,
    undefined,
    undefined,
    SOLSEA_URL
  );
};
/**
 *
 * @param vaultAddress Address of vault pda which lists nfts on solsea
 */
export const refreshSolseaDataAfterListing = async (vaultAddress?: string) => {
  await fetch(`${SOLSEA_REFRESH_URI}${vaultAddress}${RELOAD}`);
};
